import '../styles/index.css';
// import '../styles/index.scss';

console.log('catlover is a good lover');
